const instrument = (event, payload) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event, ...payload })
}

export const instrumentSignIn = payload => {
  instrument("signIn", { currentUser: payload })
}
